import Footer from "../components/footer";
import NavBar from "../components/navbar";
import React, { useEffect, useState } from "react";
import PocketBase from "pocketbase";
import NewsItem from "../components/newsItem";

export default function News() {
  const pb = new PocketBase("https://friendsofstandrewsstatepark.org");
  let [newsItems, setNewsItems] = useState([]);
  let [loading, setLoading] = useState(true);
  useEffect(() => {
    (async () => {
      const records = await pb.collection("news").getFullList({
        sort: "-created",
        fields: "id,image,title,description,created",
      });
      setNewsItems(records);
      setLoading(false);
    })();
  }, []);
  return (
    <div className="content d-flex flex-column justify-content-between w-100 h-auto fsa-body-bg news">
      <NavBar />
      <div className="d-flex flex-column flex-fill align-items-center px-3 pt-4 pb-5">
        <h1 className="fsa-section-title">News</h1>
        <div className="d-flex flex-column w-100 align-items-center">
          {loading ? (
            <p className="text-muted fst-italic">Loading...</p>
          ) : newsItems.length > 0 ? (
            newsItems.map((item) => (
              <NewsItem
                key={item.id}
                image={item.image}
                recKey={item.id}
                title={item.title}
                description={item.description}
                date={item.created}
              />
            ))
          ) : (
            <div className={"d-flex add-text-shadow h1"}>Nothing to Report</div>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
}
